// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reworkInput-container .breadcrum-cross-icon-wrapper .breadcrums-wrapper {
  margin-left: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.reworkInput-container nav {
  padding: 1.5rem 2rem;
}
.reworkInput-container nav .p-menuitem-text {
  cursor: pointer;
}
.reworkInput-container .lastElement {
  color: #003da5;
  font-size: 14px;
  font-weight: 600;
}
.reworkInput-container .project-title {
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 24.38px;
  color: #003da5;
  padding: 0 22px;
}
.reworkInput-container .task_header {
  background-color: rgb(237, 244, 250);
}
.reworkInput-container .task_header .project_name {
  padding: 9px 25px;
  color: #003da5;
}
.reworkInput-container .checkbox_wrapper {
  display: flex;
  padding: 9px 18px;
}
.reworkInput-container .p-checkbox + label {
  font-size: 12px;
}
.reworkInput-container .disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.reworkInput-container .pi-times {
  position: absolute;
  width: 14px;
  height: 14px;
  right: 41px;
  top: 23px;
  cursor: pointer;
}

.headerWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}
.headerWrapper .pi-angle-down {
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms ease all;
  color: #003da5;
  font-size: 2rem;
  transition: 0.5s;
}
.headerWrapper .pi-angle-down:not(.collapsed) {
  transform: rotate(180deg);
}
.headerWrapper .pi-angle-down:is(.collapsed) {
  transform: rotate(0deg);
}
.headerWrapper .pi-angle-right {
  font-weight: normal;
  font-size: 0.875rem;
}

.infoImage {
  cursor: pointer;
}

.actions-rework {
  padding-right: 2.625rem;
  display: flex;
  justify-content: space-between;
  padding: 0.938rem 2.625rem;
}

.action-button-rework {
  display: flex;
  gap: 1.25rem;
}

.myProjectAnddAllProjectList {
  overflow: scroll;
}
.myProjectAnddAllProjectList .checked-row {
  color: red;
}
.myProjectAnddAllProjectList .checked-row .p-inputtext {
  color: red;
}
.myProjectAnddAllProjectList .change-colour {
  color: #002c7a;
}
.myProjectAnddAllProjectList .disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.myProjectAnddAllProjectList .SelectionPopUpOverlay {
  width: 100%;
}

#pr_id_2_content {
  width: 100%;
}

footer {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  position: fixed;
  right: 2.5rem;
  bottom: 1.25rem;
}

button {
  cursor: pointer;
}

.p-breadcrumb .p-breadcrumb-list li.p-menuitem-separator {
  margin: 0 0.5rem 0 0.5rem;
  color: grey;
}
.p-breadcrumb .p-breadcrumb-list li:last-child .p-menuitem-text {
  color: #003da5;
  font-weight: 600;
}
.p-breadcrumb .p-breadcrumb-list .lastElement {
  color: #003da5;
  font-size: 14px;
  font-weight: 600;
}

footer {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  position: fixed;
  right: 2.5rem;
  bottom: 1.25rem;
  margin-right: 20px;
}

#reworkDialog .p-dialog-content {
  padding: 0;
  width: 90vw;
  min-height: 12.5rem header;
  min-height-color: #003da5;
  min-height-font-weight: bold;
  min-height-padding: 0.625rem 0rem;
  min-height-background: #edf4fa;
  min-height-padding-left: 1.063rem;
}
#reworkDialog .p-dialog-content .contentWrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}
#reworkDialog .p-dialog-content .markup {
  color: #003da5;
}
#reworkDialog .p-dialog-content .flex-item {
  position: relative;
  font-weight: bold;
}
#reworkDialog .p-dialog-content .flex-item select,
#reworkDialog .p-dialog-content .flex-item input,
#reworkDialog .p-dialog-content .flex-item .markup {
  margin-top: 0.625rem;
  min-width: 12.375rem;
  max-width: 8.375rem;
}
#reworkDialog .p-dialog-content .flex-item:not(:first-child):after {
  content: "";
  position: absolute;
  background: #acacac;
  width: 0.063rem;
  height: 100%;
  top: 0%;
  left: -0.938rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ReworkPage/reworkInput.scss"],"names":[],"mappings":"AAKI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAJN;AAOE;EACE,oBAAA;AALJ;AAMI;EACE,eAAA;AAJN;AAQE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AANJ;AASE;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AAPJ;AAUE;EACE,oCAAA;AARJ;AASI;EACE,iBAAA;EACA,cAAA;AAPN;AAWE;EACE,aAAA;EACA,iBAAA;AATJ;AAaI;EACE,eAAA;AAXN;AAeE;EACE,YAAA;EACA,mBAAA;AAbJ;AAeE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAbJ;;AAkBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAfF;AAiBE;EACE,eAAA;EACA,yBAAA;EAIA,0BAAA;EACA,cA/EM;EAgFN,eAAA;EACA,gBAAA;AAfJ;AAiBI;EACE,yBAAA;AAfN;AAkBI;EACE,uBAAA;AAhBN;AAoBE;EACE,mBAAA;EACA,mBAAA;AAlBJ;;AAwBA;EACE,eAAA;AArBF;;AAwBA;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,0BAAA;AArBF;;AAwBA;EACE,aAAA;EACA,YAAA;AArBF;;AAwBA;EACE,gBAAA;AArBF;AAuBE;EACE,UAAA;AArBJ;AAsBI;EACE,UAAA;AApBN;AAuBE;EACE,cAAA;AArBJ;AAwBE;EACE,YAAA;EACA,mBAAA;AAtBJ;AAyBC;EACC,WAAA;AAvBF;;AA0BA;EACE,WAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAvBF;;AA0BA;EACE,eAAA;AAvBF;;AA4BI;EACE,yBAAA;EACA,WAAA;AAzBN;AAiCM;EACE,cAxKE;EAyKF,gBAAA;AA/BR;AAkCI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAhCN;;AAqCA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAlCF;;AAsCE;EACE,UAAA;EACA,WAAA;EAEA,0BAAA;EACE,yBApMI;EAqMJ,4BAAA;EACA,iCAAA;EACA,8BAAA;EACA,iCAAA;AApCN;AAuCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AArCN;AAwCI;EACE,cArNI;AA+KV;AAyCI;EACE,kBAAA;EACA,iBAAA;AAvCN;AAyCM;;;EAGE,oBAAA;EACA,oBAAA;EACA,mBAAA;AAvCR;AA2CI;EACE,WAAA;EACA,kBAAA;EACA,mBAvOM;EAwON,eAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;AAzCN","sourcesContent":["$primary: #003da5;\n$secondary: #acacac;\n\n.reworkInput-container {\n  .breadcrum-cross-icon-wrapper{\n    .breadcrums-wrapper{\n      margin-left: 24px;\n      margin-top: 20px;\n      margin-bottom: 10px;\n    }\n  }\n  nav {\n    padding: 1.5rem 2rem;\n    .p-menuitem-text {\n      cursor: pointer;\n    }\n  }\n\n  .lastElement {\n    color: #003da5;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  .project-title {\n    font-weight: 500;\n    font-size: 1.5rem;\n    line-height: 24.38px;\n    color: #003da5;\n    padding: 0 22px;\n  }\n\n  .task_header {\n    background-color: rgb(237, 244, 250);\n    .project_name {\n      padding: 9px 25px;\n      color: #003da5;\n    }\n  }\n\n  .checkbox_wrapper {\n    display: flex;\n    padding: 9px 18px;\n  }\n\n  .p-checkbox {\n    + label {\n      font-size: 12px;\n    }\n  }\n\n  .disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  .pi-times {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    right: 41px;\n    top: 23px;\n    cursor: pointer;\n  }\n}\n\n\n.headerWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n\n  .pi-angle-down {\n    cursor: pointer;\n    transform: rotate(180deg);\n    -webkit-transition: 300ms ease all;\n    -moz-transition: 300ms ease all;\n    -o-transition: 300ms ease all;\n    transition: 300ms ease all;\n    color: $primary;\n    font-size: 2rem;\n    transition: 0.5s;\n\n    &:not(.collapsed) {\n      transform: rotate(180deg);\n    }\n\n    &:is(.collapsed) {\n      transform: rotate(0deg);\n    }\n  }\n\n  .pi-angle-right {\n    font-weight: normal;\n    font-size: 0.875rem;\n  }\n}\n\n\n\n.infoImage {\n  cursor: pointer;\n}\n\n.actions-rework {\n  padding-right: 2.625rem;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.938rem 2.625rem;\n}\n\n.action-button-rework {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.myProjectAnddAllProjectList {\n  overflow: scroll;\n\n  .checked-row {\n    color: red;\n    .p-inputtext {\n      color: red;\n    }\n  }\n  .change-colour {\n    color: #002c7a;\n  }\n\n  .disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n .SelectionPopUpOverlay {\n  width: 100%;\n }\n}\n#pr_id_2_content {\n  width: 100%;\n}\n\nfooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 2rem;\n  position: fixed;\n  right: 2.5rem;\n  bottom: 1.25rem;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.p-breadcrumb {\n  .p-breadcrumb-list {\n    li.p-menuitem-separator {\n      margin: 0 0.5rem 0 0.5rem;\n      color: grey;\n    }\n\n    // li:nth-child(1) {\n    //   display: none;\n    // }\n\n    li:last-child {\n      .p-menuitem-text {\n        color: $primary;\n        font-weight: 600;\n      }\n    }\n    .lastElement{\n      color: #003da5;\n      font-size: 14px;\n      font-weight: 600;\n    }\n  }\n}\n\nfooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 2rem;\n  position: fixed;\n  right: 2.5rem;\n  bottom: 1.25rem;\n  margin-right: 20px;\n}\n\n#reworkDialog{\n  .p-dialog-content {\n    padding: 0;\n    width: 90vw;\n  \n    min-height:12.5rem header {\n      color: $primary;\n      font-weight: bold;\n      padding: 0.625rem 0rem;\n      background: #edf4fa;\n      padding-left: 1.063rem;\n    }\n  \n    .contentWrapper {\n      display: flex;\n      flex-flow: row wrap;\n      justify-content: space-between;\n      list-style: none;\n      padding: 0;\n      margin-bottom: 2rem;\n    }\n  \n    .markup {\n      color: $primary;\n    }\n  \n    .flex-item {\n      position: relative;\n      font-weight: bold;\n  \n      select,\n      input,\n      .markup {\n        margin-top: 0.625rem;\n        min-width: 12.375rem;\n        max-width: 8.375rem;\n      }\n    }\n  \n    .flex-item:not(:first-child):after {\n      content: '';\n      position: absolute;\n      background: $secondary;\n      width: 0.063rem;\n      height: 100%;\n      top: 0%;\n      left: -0.938rem;\n      // transform: translateY(-50%);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
